var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AreaLayer, AreaLayer2 } from './Components/AreaLayer';
import { ChartTooltip } from './Components/Tooltip';
export var getLineOptionsByVariant = function (variant, config) {
  var chartLineForContribution = config.chartLineForContribution,
    chartLineForProjection = config.chartLineForProjection,
    xAxisFormatter = config.xAxisFormatter,
    xFormat = config.xFormat,
    xTickValues = config.xTickValues,
    yFormat = config.yFormat,
    yAxisFormatter = config.yAxisFormatter,
    setChanceValues = config.setChanceValues,
    defaultChanceValues = config.defaultChanceValues,
    onDataPointChange = config.onDataPointChange,
    chartTooltipText = config.chartTooltipText,
    theme = config.theme;
  var baseOptions = {
    axisLeft: null,
    colors: {
      datum: 'color'
    },
    curve: 'monotoneX',
    data: [__assign(__assign({}, chartLineForContribution), {
      color: theme.tokens.chart.secondary.main
    }), __assign(__assign({}, chartLineForProjection), {
      color: theme.tokens.chart.primary.main
    })],
    enableGridX: false,
    layers: [AreaLayer, AreaLayer2, 'grid', 'markers', 'axes', 'areas', 'crosshair', 'lines', 'points', 'mesh', 'legends'],
    lineWidth: 3,
    margin: variant === 'simple' ? {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    } : {
      top: 5,
      right: 78,
      bottom: 30,
      left: 30
    },
    theme: {
      fontSize: theme.typography.font.sizes.small,
      crosshair: {
        line: {
          stroke: theme.tokens.interface.neutral.strong
        }
      },
      axis: {
        domain: {
          line: {
            stroke: variant === 'simple' ? theme.tokens.interface.neutral.light : theme.tokens.interface.neutral.regular,
            strokeWidth: variant === 'simple' ? 2 : 1
          }
        },
        ticks: {
          line: {
            stroke: theme.tokens.interface.neutral.regular
          },
          text: {
            fill: theme.tokens.text.label.regular
          }
        }
      },
      grid: {
        line: {
          stroke: theme.tokens.interface.neutral.light,
          strokeWidth: 1
        }
      }
    },
    xFormat: xFormat,
    yFormat: yFormat,
    xScale: {
      format: '%Y-%m-%d',
      precision: 'day',
      type: 'time',
      useUTC: false
    },
    yScale: {
      type: 'linear',
      min: Math.min.apply(Math, chartLineForProjection.data.map(function (x) {
        return x.lowConfidenceYLow;
      })),
      max: chartLineForProjection.data.slice(-1)[0].lowConfidenceYHigh
    }
  };
  switch (variant) {
    case 'simple':
      // @ts-ignore
      return __assign(__assign({}, baseOptions), {
        axisBottom: {
          format: xAxisFormatter,
          legend: '',
          tickPadding: 5,
          tickRotation: 0,
          tickSize: 0,
          tickValues: 0
        },
        axisRight: undefined,
        enableGridY: false,
        enablePoints: false,
        isInteractive: false
      });
    case 'default':
    default:
      return __assign(__assign({}, baseOptions), {
        axisBottom: {
          format: xAxisFormatter,
          legend: '',
          tickPadding: 5,
          tickRotation: 0,
          tickSize: 8,
          tickValues: xTickValues
        },
        axisRight: {
          format: yAxisFormatter,
          legend: '',
          tickPadding: 5,
          tickRotation: 0,
          tickSize: 8
        },
        crosshairType: 'x',
        enableCrosshair: true,
        enableGridY: true,
        enablePoints: true,
        onMouseLeave: setChanceValues && defaultChanceValues ? function () {
          return setChanceValues(defaultChanceValues);
        } : undefined,
        // @ts-ignore
        tooltip: chartTooltipText && onDataPointChange ? function (x) {
          return _jsx(ChartTooltip, {
            chartTooltipText: chartTooltipText,
            pointValues: onDataPointChange(x.point.data)
          });
        } : null,
        useMesh: true
      });
  }
};